import { BookingChannel } from '@/auth/scopes';

export function channelOfReservationType(
  reservationType: string | null | undefined,
): BookingChannel {
  return reservationType?.startsWith('Online')
    ? BookingChannel.ONLINE
    : BookingChannel.MANUAL;
}

export function isChannelInScope(
  channel: BookingChannel,
  granted: readonly BookingChannel[],
): boolean {
  return granted.includes(channel);
}
